import { cn } from "@/lib/utils"
import { useEffect, useRef, useState } from "react"
import LoadingBar, { LoadingBarRef } from "react-top-loading-bar"

interface LoadingBarTopProps {
  loading?: boolean
  delay?: number
}

function LoadingBarTop(props: LoadingBarTopProps) {
  const ref = useRef<LoadingBarRef>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (props.loading) {
      setTimeout(() => {
        setLoading(true)
        ref.current?.continuousStart()
      }, props.delay ?? 100)
    } else if (loading) {
      setLoading(false)
      ref.current?.complete()
    }
  }, [props.loading])

  return (
    <LoadingBar
      color="#9aa5b2"
      height={4}
      ref={ref}
      shadow={false}
      className=""
      containerClassName={cn("!absolute left-0 top-0 transition-colors", loading && "!bg-[#d1dfec]")}
    />
  )
}

export default LoadingBarTop
